import { render, staticRenderFns } from "./couponCodeAdd.vue?vue&type=template&id=2ff99ff6&scoped=true"
import script from "./couponCodeAdd.vue?vue&type=script&lang=js"
export * from "./couponCodeAdd.vue?vue&type=script&lang=js"
import style0 from "./couponCodeAdd.vue?vue&type=style&index=0&id=2ff99ff6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff99ff6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff99ff6')) {
      api.createRecord('2ff99ff6', component.options)
    } else {
      api.reload('2ff99ff6', component.options)
    }
    module.hot.accept("./couponCodeAdd.vue?vue&type=template&id=2ff99ff6&scoped=true", function () {
      api.rerender('2ff99ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/scanCouponCode/couponCodeAdd.vue"
export default component.exports